import axios from 'axios';
import monitorStore from './model';

export function getMonitor() {
    return axios.get('/zhgd/index/monitor?pageNo=1&pageSize=100')
        .then((data) => {
            monitorStore.setMonitors(data.result);
        })
        .catch((e) => console.log(e));
}
